if (!customElements.get('sort-collection-by')) {
  class SortCollectionBy extends HTMLElement {
    constructor() {
      super();
      this.CollectionFiltersForm = document.querySelector('collection-filters-form');

      // Stop when this element is not found on the page.
      if (!this.CollectionFiltersForm) return;

      // Check open or closed state.
      this.isOpen = this.classList.contains('open');

      // Assign event listener to the trigger.
      this.buttonTrigger = this.querySelector('[data-sort-collection-by="trigger"]');
      this.buttonTrigger.addEventListener('click', () => {
        this.handleTriggerClick();
      });

      // Assign event listeners to the options.
      this.options = this.querySelectorAll('[data-sort-collection-by="option"]');
      this.options.forEach((option) => {
        option.addEventListener('change', (event) => {
          this.handleOptionChange(event);
          this.close();
        });
      });
    }

    /**
     * handleTriggerClick
     * Trigger open or close action of the dropdown.
     */
    handleTriggerClick() {
      this.isOpen = !this.isOpen;
      this.isOpen ? this.open() : this.close();
    }

    /**
     * Open
     * Open the dropdown.
     */
    open() {
      this.classList.add('open');
    }

    /**
     * Close
     * Close the dropdown.
     */
    close() {
      this.classList.remove('open');
      this.isOpen = false;
    }

    /**
     * handleOptionChange
     * @param {Object} event
     */
    handleOptionChange(event) {
      const currentSelectedOption = event.currentTarget;

      const url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);

      params.set('sort_by', currentSelectedOption.value);

      this.CollectionFiltersForm.renderPage(params.toString());
    }
  }
  customElements.define('sort-collection-by', SortCollectionBy);
}
